import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Input } from '../Input';
import { InputWrapper } from './InputWrapper';
import { TextInputIcon } from './TextInputIcon';
export var TextInput = React.forwardRef(function (_ref, ref) {
  var leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      rightButton = _ref.rightButton,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      isInvalid = _ref.isInvalid,
      error = _ref.error,
      _ref$isTouched = _ref.isTouched,
      isTouched = _ref$isTouched === void 0 ? false : _ref$isTouched,
      _ref$isIconBgTranspar = _ref.isIconBgTransparent,
      isIconBgTransparent = _ref$isIconBgTranspar === void 0 ? true : _ref$isIconBgTranspar,
      lss = _ref.lss,
      props = _objectWithoutProperties(_ref, ["leftIcon", "rightIcon", "rightButton", "disabled", "isInvalid", "error", "isTouched", "isIconBgTransparent", "lss"]);

  return React.createElement(InputWrapper, {
    disabled: disabled,
    title: error ? error : undefined,
    isInvalid: isInvalid,
    isTouched: isTouched,
    lss: lss
  }, leftIcon && React.createElement(TextInputIcon, {
    isIconBgTransparent: isIconBgTransparent,
    position: "left"
  }, leftIcon), React.createElement(Input, Object.assign({
    disabled: disabled
  }, props, {
    ref: ref
  })), rightIcon && React.createElement(TextInputIcon, {
    isIconBgTransparent: isIconBgTransparent,
    position: "right"
  }, rightIcon), rightButton);
});